import { render, staticRenderFns } from "./InactivationForm.vue?vue&type=template&id=62266abf&"
import script from "./InactivationForm.vue?vue&type=script&lang=js&"
export * from "./InactivationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports